import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#CF4520',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#EC712E',
        },
    }),
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    text: {
        primary: '#353435',
        dark: '#323232',
    },
    common: {
        black: '#353435',
        white: '#fff',
        'faux-white': '#F4F4F4',
        'faux-black': '#122B3B',
    },
    blue: {
        light: '#E6EDF9',
        medium: '#8AAAE2',
        dark: '#2A64CA',
    },
    shadow: {
        main: '#00000022',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#009242' },
        }),
        mildCategory: augmentColor({
            color: { main: '#EC712E' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#FF0000' },
        }),
    },
    roundButton: {
        layers: {
            first: '#353435',
            second: '#DD8D60',
            third: '#F5B896',
            forth: '#EDEAE466',
        },
    },
};
